import React from 'react'
import PropTypes from 'prop-types'
import { Button, TextField } from '@material-ui/core'
import { makeStyles } from '@material-ui/core/styles'
import { Form, Field } from 'react-final-form'
import {
  composeValidators,
  required,
  mustBeEmail,
  mustBePassword,
} from '../../../utils/formValidators'
import { useTranslation } from 'react-i18next'

const useStyles = makeStyles((theme) => ({
  form: {
    width: '100%', // Fix IE 11 issue.
    marginTop: theme.spacing(1),
  },
  submit: {
    margin: theme.spacing(3, 0, 2),
  },
}))

export default function LoginForm({ isLoading, onSubmit }) {
  const classes = useStyles()

  const { t } = useTranslation()

  return (
    <Form onSubmit={onSubmit}>
      {({ handleSubmit }) => (
        <form className={classes.form} noValidate onSubmit={handleSubmit}>
          <Field
            name="username"
            validate={composeValidators(required, mustBeEmail)}
          >
            {({ input, meta }) => (
              <TextField
                variant="outlined"
                margin="normal"
                required
                fullWidth
                autoFocus
                id="email"
                label={t('login.email')}
                name="username"
                autoComplete="email"
                error={meta.touched && Boolean(meta.error)}
                helperText={meta.touched && meta.error ? meta.error : ' '}
                {...input}
              />
            )}
          </Field>
          <Field
            name="password"
            validate={composeValidators(required, mustBePassword)}
          >
            {({ input, meta }) => (
              <TextField
                variant="outlined"
                margin="normal"
                required
                fullWidth
                name="password"
                label={t('login.password')}
                type="password"
                id="password"
                autoComplete="current-password"
                error={meta.touched && Boolean(meta.error)}
                helperText={meta.touched && meta.error ? meta.error : ' '}
                {...input}
              />
            )}
          </Field>
          <Button
            type="submit"
            fullWidth
            variant="contained"
            color="primary"
            className={classes.submit}
            disabled={isLoading}
          >
            {t('login.se_connecter')}
          </Button>
        </form>
      )}
    </Form>
  )
}
LoginForm.propTypes = {
  isLoading: PropTypes.bool.isRequired,
  onSubmit: PropTypes.func.isRequired,
}
